(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/team-show-link.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/team-show-link.js');
'use strict';

const Icon = svs.ui.ReactIcon;
const {
  ReactButton: Button
} = svs.ui;
const {
  buildInviteLinkUrl
} = svs.arena.pages.teams.helpers;
const {
  showCopyInviteLinkSuccess
} = svs.arena.pages.teams.dialogs;
const {
  IconText
} = svs.tb_ui_react.icon_text;
const TeamShowLink = _ref => {
  let {
    isExpanded = true,
    teamId,
    isCreate = false
  } = _ref;
  const inviteIds = ReactRedux.useSelector(state => {
    var _state$teams;
    return (_state$teams = state.teams) === null || _state$teams === void 0 ? void 0 : _state$teams.inviteIds;
  }) || [];
  const [isLinkOld, setIsLinkOld] = React.useState(false);
  const linkId = inviteIds.find(item => item.teamId === teamId);
  React.useEffect(() => {
    svs.arena.logger.debug('TeamShowLink, useEffect running');
    if (isExpanded && linkId !== null && linkId !== void 0 && linkId.validTo) {
      const isTooOld = dateFns.compareAsc(Date.now(), dateFns.addDays(dateFns.parseISO(linkId.validTo), -5));
      setIsLinkOld(isTooOld === 1);
    }
  }, [isExpanded, linkId.validTo]);
  const copyLinkToClipBoard = async () => {
    svs.arena.logger.debug('TeamShowLink, copyLinkToClipBoard');
    svs.ui.loader.show();
    try {
      await navigator.clipboard.writeText(buildInviteLinkUrl(linkId.linkId));
      const track = {
        category: 'spela-tillsammans',
        action: isCreate ? 'new_team' : 'invite_members',
        opt_label: 'copy_link'
      };
      svs.components.analytics.trackEvent(track);
    } catch (error) {}
    svs.ui.loader.hide();
    showCopyInviteLinkSuccess();
  };
  return React.createElement("div", null, linkId && React.createElement("div", {
    className: "align-center"
  }, React.createElement("div", {
    className: "bg-tur-100 padding-1 u-border-radius-4 margin-v align-center f-body"
  }, buildInviteLinkUrl(linkId.linkId)), isLinkOld && React.createElement(IconText, {
    className: "margin-v u-flex-justify-content-center"
  }, ' ', 'Länken är giltig fram till ', ' ', svs.utils.date.FormatTime('d MMM', linkId.validTo), ' '), React.createElement(Button, {
    block: true,
    className: "margin-top-1",
    iconPosition: "right",
    inverted: true,
    onClick: copyLinkToClipBoard,
    size: 300
  }, React.createElement(Icon, {
    icon: "link"
  }), "Kopiera l\xE4nk")));
};
svs.arena.pages.teams.components.TeamShowLink = TeamShowLink;

 })(window);